/* Hat Customizer Web Component */
(function () {
  'use strict';

  // Actual embroidery thread colors available for text customization
  const THREAD_COLORS = [
    { name: 'White',          hex: '#ffffff', code: 'Polyneon 1801' },
    { name: 'Black',          hex: '#000000', code: 'Polyneon 1800' },
    { name: 'Gray',           hex: '#808080', code: 'Polyneon 1918' },
    { name: 'Silver',         hex: '#c0c0c0', code: 'Polyneon 1611' },
    { name: 'Metallic Gold',  hex: '#d4af37', code: 'Metallic 4003' },
    { name: 'Metallic Silver',hex: '#aaa9ad', code: 'Metallic 4010' },
    { name: 'Deep Gold',      hex: '#b8860b', code: 'Polyneon 1670' },
    { name: 'Golden Yellow',  hex: '#ffd700', code: 'Isacord 0600'  },
    { name: 'Yellow Gold',    hex: '#ffc200', code: 'Polyneon 1624' },
    { name: 'Neon Yellow',    hex: '#f5ff00', code: 'Polyneon 1935' },
    { name: 'Neon Lime',      hex: '#bfff00', code: 'Polyneon 1950' },
    { name: 'Neon Orange',    hex: '#ff6600', code: 'Polyneon 1946' },
    { name: 'Orange',         hex: '#ff8c00', code: 'Polyneon 1678' },
    { name: 'Coral Pink',     hex: '#ff6b6b', code: 'Polyneon 1721' },
    { name: 'Pink',           hex: '#ff69b4', code: 'Polyneon 1709' },
    { name: 'Peach',          hex: '#ffb3a0', code: 'Polyneon 1820' },
    { name: 'Kelly Green',    hex: '#4cbb17', code: 'Polyneon 1988' },
    { name: 'Teal',           hex: '#008080', code: 'Classic 1093'  },
    { name: 'Turquoise',      hex: '#40e0d0', code: 'Classic 1295'  },
    { name: 'Blue',           hex: '#2962ff', code: 'Polyneon 1133' },
    { name: 'Royal Blue',     hex: '#4169e1', code: 'Polyneon 1076' },
    { name: 'Lavender',       hex: '#967bb6', code: 'Polyneon 1232' },
    { name: 'Purple',         hex: '#800080', code: 'Polyneon 1112' },
  ];

  const FONT_MAP = {
    full_block:    'Anton, Impact, sans-serif',
    shadow_3d:     'Anton, Impact, sans-serif', // rendered with canvas drop-shadow, same base font
    madison:       "'Playfair Display', Georgia, serif",
    ivory:         "'Cormorant Garamond', Georgia, serif",
    hobo:          "'Lobster', cursive",
    zap:           "'Bebas Neue', Impact, sans-serif",
    brush_script:  'Pacifico, cursive',
    custom_script: "'Dancing Script', cursive",
  };

  // Variant IDs for hidden add-on products in Shopify.
  // Create products in Shopify Admin → Products, set as hidden/unavailable on storefront,
  // then paste each variant's ID here.
  const ADD_ON_VARIANTS = {
    text:   47662052376770, // $6.99 — side text, back text, headphone logo
    upload: 47662052442306, // $9.99 — logo upload
  };

  const STEPS     = ['Style', 'Front Logo', 'Left Side', 'Right Side', 'Back', 'Review'];
  const SUBTITLES = [
    'Choose your hat color and size',
    'Design your front logo',
    'Customize the left side',
    'Customize the right side',
    'Customize the back panel',
    'Review your design',
  ];

  // Which view image to show per step (back for step 4 only)
  const STEP_VIEW  = { 0: 'front', 1: 'front', 2: 'front', 3: 'front', 4: 'back', 5: 'front' };
  const VIEW_LABEL = { front: 'Front', back: 'Back' };

  // Zone overlay active state per step (step 0 = color, no overlay)
  const STEP_ZONE = { 1: 'front', 2: 'left', 3: 'right', 4: 'back' };
  const ZONE_STEP = { style: 0, front: 1, left: 2, right: 3, back: 4, review: 5 };

  // ── Homography helpers — true perspective transform for stage canvas overlay ──
  // Solves 8×8 linear system via Gaussian elimination with partial pivoting.
  function _solveLinear8(A, b) {
    const n = 8, M = A.map((r, i) => [...r, b[i]]);
    for (let c = 0; c < n; c++) {
      let maxR = c;
      for (let r = c + 1; r < n; r++) if (Math.abs(M[r][c]) > Math.abs(M[maxR][c])) maxR = r;
      [M[c], M[maxR]] = [M[maxR], M[c]];
      const piv = M[c][c];
      if (Math.abs(piv) < 1e-10) continue;
      for (let r = 0; r < n; r++) {
        if (r === c) continue;
        const f = M[r][c] / piv;
        for (let k = c; k <= n; k++) M[r][k] -= f * M[c][k];
      }
    }
    return M.map((r, i) => r[n] / r[i]);
  }
  // Returns 3×3 homography H (row-major, H[2][2]=1) mapping src[i]→dst[i].
  function _computeHomography(src, dst) {
    const A = [], b = [];
    for (let i = 0; i < 4; i++) {
      const [x, y] = src[i], [u, v] = dst[i];
      A.push([x, y, 1, 0, 0, 0, -x * u, -y * u]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -x * v, -y * v]); b.push(v);
    }
    const h = _solveLinear8(A, b);
    return [[h[0], h[1], h[2]], [h[3], h[4], h[5]], [h[6], h[7], 1]];
  }
  // Packs H into a CSS matrix3d string. Element must have transform-origin: 0 0.
  function _homographyToCSS(H) {
    return `matrix3d(${H[0][0]},${H[1][0]},0,${H[2][0]},` +
           `${H[0][1]},${H[1][1]},0,${H[2][1]},0,0,1,0,` +
           `${H[0][2]},${H[1][2]},0,${H[2][2]})`;
  }
  // Converts legacy {left,top,width,height} zone format to [[x,y]×4] corners.
  function _legacyToCorners({ left = 20, top = 30, width = 40, height = 35 }) {
    return [[left, top], [left + width, top], [left + width, top + height], [left, top + height]];
  }

  // Zone corners as % of the rendered hat IMAGE (not the stage element).
  // Order: TL, TR, BR, BL. Calibrate with hc._injectCalibrationTool('front').
  // '_default' applies to all products until handle-specific coords are added.
  const PRODUCT_ZONES = {
    _default: {
      // logo2 defaults to the same corners as logo1 — every product likely
      // needs its own distinct logo2 calibration eventually (IJDS block
      // initials sit differently than the 2-line signature logo), this is
      // just an explicit starting point instead of relying on the implicit
      // fallback in _positionStageCanvases.
      front: {
        corners: [[30.2, 42], [61.1, 41.2], [60.4, 65.4], [29.2, 60.9]],
        logo2: { corners: [[30.2, 42], [61.1, 41.2], [60.4, 65.4], [29.2, 60.9]] },
      },
    },
    'decky-3500-flat-bill': {
      // Calibrated 2026-05-15 @ 2048×1152, DPR 1.25, stage 1608×889, image 889×889 @(360,0)
      // logo2 not yet separately calibrated — defaulted to the same corners as logo1.
      front: {
        corners: [[30.2, 42], [61.1, 41.2], [60.4, 65.4], [29.2, 60.9]],
        logo2: { corners: [[30.2, 42], [61.1, 41.2], [60.4, 65.4], [29.2, 60.9]] },
      },
    },
    'decky-1096-patch': {
      // Calibrated 2026-05-31 @ 2048×1152, DPR 1.25, stage 1608×889, image 889×889 @(360,0)
      // logo2 not yet separately calibrated — defaulted to the same corners as logo1.
      front: {
        corners: [[24.6, 36.5], [59, 37.4], [57.1, 70.1], [25.6, 64.1]],
        logo2: { corners: [[24.6, 36.5], [59, 37.4], [57.1, 70.1], [25.6, 64.1]] },
      },
    },
    'bandana-brim': {
      // Base corners = Navy variant (48497654399170), calibrated 2026-08-15
      // @ 2048×1152, DPR 1.25, stage 1608×889, image 889×889 @(360,0).
      // Other color variants use their own product photo and need their own
      // corners — add them under `variants`, keyed by variant ID, each shaped
      // like the top-level `front: { corners, logo2 }` below (the `front:`
      // wrapper is required — a bare `{ corners, logo2 }` under a variant ID
      // will not resolve). To capture one: select that variant on the PDP,
      // run hc._injectCalibrationTool('front'), then click "Apply & Log" and
      // paste the logged entry here.
      front: {
        corners: [[27.3, 41.8], [70.2, 41.8], [70.2, 73], [27.3, 73]],
        logo2: { corners: [[27.8, 42.3], [70.7, 43.3], [70, 74.5], [27.1, 73.5]] },
      },
      variants: {
        // Red — calibrated 2026-08-15 @ 2048×1152, DPR 1.25, stage 1608×889, image 889×889 @(360,0)
        48497654431938: {
          front: {
            corners: [[27.7, 37.2], [70.6, 39.2], [69.2, 70.4], [26.2, 68.4]],
            logo2: { corners: [[28.3, 40.5], [69.2, 41.7], [68.4, 71.4], [27.5, 70.3]] },
          },
        },
      },
    },
    'kbethos-aztec-brim-black': {
      // Calibrated 2026-06-17 @ 2048×1152, DPR 1.25, stage 568×889, image 568×568 @(0,161)
      front: {
        corners: [[26, 26.3], [74.7, 25.9], [72.7, 62.9], [26.7, 62.3]],
        logo2: { corners: [[26.7, 30], [70.5, 31], [69.9, 63.6], [29.9, 61.9]] },
      },
    },
    'kbethos-tie-dye-brim-white': {
      // Re-calibrated 2026-08-29 @ 2048×1152, DPR 1.25, stage 1608×833, image 833×833 @(388,0).
      // Prior calibration undershot the right seam by ~8% and let the
      // bottom-right corner dip into the brim — widened to the true panel
      // edges and raised BR to sit on the visor line (right side rises
      // slightly in this shot's perspective).
      front: {
        corners: [[26, 31], [72, 31.5], [72.5, 63], [24.5, 65]],
        logo2: { corners: [[26, 32], [72, 32.5], [72.5, 64], [24.5, 66]] },
      },
    },

    // ── Uncalibrated placeholders below ───────────────────────────────────
    // Not yet calibrated — corners borrowed from the existing entry noted in
    // each comment because that product's source photo is the same 500×500
    // square crop/framing (confirmed via local files in data/images/). These
    // are starting points only: open the product, run
    // hc._injectCalibrationTool('front') and drag to fit, then replace.

    // Re-calibrated 2026-08-29 — this photo is its own, steeper 3/4 angle
    // (not a shared crop with decky-1096-patch as previously assumed).
    // First pass over-tapered the right edge, which read as a rotated/
    // sheared word rather than a curved panel, and undershot the left
    // edge into the white background — narrowed and toned down to a mild
    // skew matching the actual crown curve.
    'decky-paisley-1093': {
      front: {
        corners: [[26.9, 36.2], [64.8, 34.7], [65.3, 74.2], [30.2, 69.3]],
        logo2: { corners: [[26.9, 36.2], [64.8, 34.7], [65.3, 74.2], [30.2, 69.3]] },
      },
    },
    // Re-calibrated 2026-08-29 — its own 3/4-angle shot, similar rotation
    // to decky-paisley-1093 but slightly milder.
    'decky-987-animal-pattern': {
      front: {
        corners: [[28, 32], [70, 30.5], [72, 62], [26, 63]],
        logo2: { corners: [[28, 32], [70, 30.5], [72, 62], [26, 63]] },
      },
    },

    // Kbethos brim-snapback family — same brim styling and 500×500 crop as
    // kbethos-aztec-brim-black/kbethos-tie-dye-brim-white above.
    // Member colors checked: kbethos-checkered-brim-black-grey (500×500).
    // Re-calibrated 2026-08-29 — shifted down from the borrowed aztec-brim
    // corners so the text baseline sits lower/more centered on the crown
    // instead of hugging the top curve. User-approved with the mild skew
    // kept (a pure axis-aligned rectangle was also tried and looked nearly
    // identical on this near-level shot, but the slight skew was preferred).
    'kbethos-checkered-brim': {
      front: {
        corners: [[26, 34], [74.7, 33.6], [72.7, 70.6], [26.7, 70]],
        logo2: { corners: [[26.7, 37.7], [70.5, 38.7], [69.9, 71.3], [29.9, 69.6]] },
      },
    },
    // Member colors checked: kbethos-enamel-brim-black (500×500).
    'kbethos-enamel-brim': {
      front: {
        corners: [[26, 26.3], [74.7, 25.9], [72.7, 62.9], [26.7, 62.3]],
        logo2: { corners: [[26.7, 30], [70.5, 31], [69.9, 63.6], [29.9, 61.9]] },
      },
    },
    // Member colors checked: kbethos-galaxy-black (500×500).
    'kbethos-galaxy': {
      front: {
        corners: [[26, 26.3], [74.7, 25.9], [72.7, 62.9], [26.7, 62.3]],
        logo2: { corners: [[26.7, 30], [70.5, 31], [69.9, 63.6], [29.9, 61.9]] },
      },
    },
    // Member colors checked: kbethos-galaxy-brim-black (500×500).
    // logo2 calibrated 2026-07-03 @ 1920×1080, DPR 1, stage 1480×817, image 817×817 @(332,0).
    'kbethos-galaxy-brim': {
      front: {
        corners: [[30.3, 43.7], [66.3, 43.7], [66.3, 69.8], [30.3, 69.8]],
        logo2: { corners: [[30.4, 44.5], [66.4, 44.5], [66.4, 70.7], [30.4, 70.7]] },
      },
    },
    // kbethos-ostrich-brim-black-red (500×500) — solo product, same brim family.
    'kbethos-ostrich-brim-black-red': {
      front: {
        corners: [[26, 26.3], [74.7, 25.9], [72.7, 62.9], [26.7, 62.3]],
        logo2: { corners: [[26.7, 30], [70.5, 31], [69.9, 63.6], [29.9, 61.9]] },
      },
    },

    // kbethos-galaxy-snapback-kgn — source photo is 3024×4032 (portrait phone
    // photo, NOT the square studio crop the other entries share), so no
    // existing entry is a safe starting shape. Left at the generic _default
    // rectangle; needs a full fresh calibration pass, not just fine-tuning.
    'kbethos-galaxy-snapback-kgn': {
      front: {
        corners: [[20, 28], [80, 28], [80, 72], [20, 72]],
        logo2: { corners: [[20, 28], [80, 28], [80, 72], [20, 72]] },
      },
    },
  };

  class HatCustomizer extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._s = {
        step: 0,
        variantId: null,
        selectedOptions: {},
        front: { logo: null, oReplacement: null, color: '#ffffff' },
        zones: {
          // Defaults to 'text' (Add Text is the default-open tab) to nudge
          // customers toward customizing instead of leaving panels blank.
          left:  { type: 'text', text: '', font: 'full_block', color: '#ffffff', image: null },
          right: { type: 'text', text: '', font: 'full_block', color: '#ffffff', image: null },
          back:  { type: 'text', text: '', font: 'full_block', color: '#ffffff', image: null },
        },
      };

      // Parse enabled zones from data-zones attribute (set by Liquid from metafields)
      const zonesAttr = this.dataset.zones || 'front,left,right,back';
      this._enabledZones = new Set(zonesAttr.split(',').map(z => z.trim()).filter(Boolean));

      this._initThreadColors();
      this._applyZoneConfig();
      ['left', 'right', 'back'].forEach(zone => this._updateZonePrice(zone));
      this._initOverlayToggle();
      this._initZoom();
      this._initCanvasZoom();
      this._bind();
      this._goTo(0);
      this._initPreviewImage();
      this._positionStageCanvases();
      // Defer initial sync so variant-picker custom element is fully ready
      setTimeout(() => this._syncFromPDP(), 0);

      // Auto-open when arriving from the catalog via ?open_customizer=1.
      // 50 ms gives body stylesheets one rAF cycle to flush before we show the dialog.
      if (new URLSearchParams(window.location.search).get('open_customizer') === '1') {
        const _url = new URL(window.location.href);
        _url.searchParams.delete('open_customizer');
        history.replaceState(null, '', _url.toString());
        setTimeout(() => { this._syncFromPDP(); this._open(); }, 50);
      }

      // Re-position canvases whenever the stage resizes (e.g. orientation change, resize)
      const stageEl = this.querySelector('.hc-hat-stage');
      if (stageEl && window.ResizeObserver) {
        this._stageResizeObserver = new ResizeObserver(() => this._positionStageCanvases());
        this._stageResizeObserver.observe(stageEl);
      }

      // Redraw active canvas on window resize (throttled — only fires after 150ms idle)
      let _rTimer;
      this._resizeHandler = () => {
        clearTimeout(_rTimer);
        _rTimer = setTimeout(() => {
          if (!this.classList.contains('is-open')) return;
          const s = this._s.step;
          if (s === 1) this._drawFront();
          else if (s === 2) this._drawZone('left');
          else if (s === 3) this._drawZone('right');
          else if (s === 4) this._drawZone('back');
        }, 150);
      };
      window.addEventListener('resize', this._resizeHandler);
    }

    // ── Switch hat preview image + orientation badge ─────────────────────────
    _switchView(view) {
      const front = this.querySelector('#hv-front');
      const back  = this.querySelector('#hv-back');
      if (view === 'back') {
        this._loadBackImage();
        front?.classList.remove('is-visible');
        back?.classList.add('is-visible');
      } else {
        back?.classList.remove('is-visible');
        front?.classList.add('is-visible');
      }
      this._currentView = view;
      const badge = this.querySelector('.hc-zone-badge');
      if (badge) badge.textContent = VIEW_LABEL[view] || view;
    }

    // ── Zone highlight overlay on hat preview ────────────────────────────────
    _highlightZone(step) {
      const active = STEP_ZONE[step];
      this.querySelectorAll('[data-zone-overlay]').forEach(el => {
        el.classList.toggle('is-active', !!active && el.dataset.zoneOverlay === active);
      });
    }

    // ── Toggle between hat photo and zone canvas in the preview panel ─────────
    // Steps 2/3/4 swap the hat photo for the matching zone canvas inside the same stage.
    // Both the sidebar canvas and this big stage canvas are painted natively by _drawZone()/_paintZoneCanvas().
    _updatePreviewPanel(step) {
      const stage = this.querySelector('.hc-hat-stage');
      if (!stage) return;

      const ZONE_LABELS = { left: 'Left Side', right: 'Right Side', back: 'Back' };
      const zoneMap = { 2: 'left', 3: 'right', 4: 'back' };
      const zone = zoneMap[step];

      // Hat photo + front overlay: visible only on non-zone steps
      stage.querySelectorAll('.hat-view, .hc-stage-canvas').forEach(el => { el.hidden = !!zone; });

      // Zone canvases: show only the active one
      stage.querySelectorAll('.hc-zone-stage-canvas').forEach(c => {
        c.hidden = c.dataset.hcCanvas !== zone;
      });

      // View label + zone badge (badge is also set by _switchView, override it for zone steps)
      const label = this.querySelector('.hc-hat-view-label');
      const badge = this.querySelector('.hc-zone-badge');
      const name  = zone ? (ZONE_LABELS[zone] || zone) : 'Front';
      if (label) label.textContent = name;
      if (badge && zone) badge.textContent = name;
    }

    // ── Thread color buttons (renders from THREAD_COLORS array) ───────────────
    _initThreadColors() {
      this.querySelectorAll('[data-zone-color], [data-front-color]').forEach(grid => {
        grid.innerHTML = '';
        THREAD_COLORS.forEach((t, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hc-text-color-btn' + (i === 0 ? ' is-selected' : ''); // default White
          btn.dataset.color = t.hex;
          btn.style.background = t.hex;
          btn.setAttribute('aria-label', `${t.name} — ${t.code}`);
          btn.title = `${t.name} (${t.code})`;
          if (t.hex === '#ffffff') btn.style.border = '1.5px solid #ccc';
          grid.appendChild(btn);
        });
      });
    }

    // ── Set initial preview image from first variant ───────────────────────────
    _initPreviewImage() {
      const variants = window.__hcVariants || [];
      const first = variants[0];
      const src = first?.featured_image?.src;
      if (src) {
        const img = this.querySelector('#hv-front');
        if (img && !img.src) img.src = src;
      }
    }

    // ── Event binding ─────────────────────────────────────────────────────────
    _bind() {
      const tid = this.dataset.triggerId;
      if (tid) document.getElementById(tid)?.addEventListener('click', () => this._open());

      // Pre-cache the correct variant image as the user picks on the PDP so
      // there's no flash when the customizer opens
      const pdpPicker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`)
                     || document.querySelector('variant-selects');
      pdpPicker?.addEventListener('change', () => this._syncFromPDP());

      this.querySelector('.hc-close')?.addEventListener('click', () => this._close());
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this._close();
      });

      this.querySelector('.hc-btn-back')?.addEventListener('click', () => {
        if (this._s.step > 0) this._goTo(this._prevEnabledStep(this._s.step - 1));
      });
      this.querySelector('.hc-btn-next')?.addEventListener('click', () => {
        const zone = { 2: 'left', 3: 'right', 4: 'back' }[this._s.step];
        if (zone) this._normalizeZoneIfEmpty(zone);
        if (this._s.step < STEPS.length - 1) this._goTo(this._nextEnabledStep(this._s.step + 1));
        else this._addToCart();
      });

      // Hat color / option swatches
      this.querySelectorAll('.hc-swatch').forEach(btn => {
        btn.addEventListener('click', () => {
          const idx   = btn.dataset.optionIndex;
          const value = btn.dataset.value;
          this.querySelectorAll(`.hc-swatch[data-option-index="${idx}"]`).forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this._s.selectedOptions[idx] = value;

          const lbl = this.querySelector(`[data-option-val="${idx}"]`);
          if (lbl) lbl.textContent = value;

          this._resolveVariant();
          this._updatePreviewImage();
          this._updateFooter();
        });
      });

      // Front logo selector
      this.querySelectorAll('.hc-logo-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          this.querySelectorAll('.hc-logo-btn').forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this._s.front.logo = btn.dataset.logo;
          this._positionStageCanvases();
          // Show/hide O replacement (logo1 only)
          const oWrap = this.querySelector('[data-o-replace]');
          if (oWrap) oWrap.hidden = this._s.front.logo !== 'logo1';
          // Reset O replacement when switching away from logo1
          if (this._s.front.logo !== 'logo1') {
            this._s.front.oReplacement = null;
            this.querySelectorAll('[data-o-shape]').forEach(b => b.classList.remove('is-selected'));
          }
          // Show thread color for logo1 and logo2 only
          const colorWrap = this.querySelector('[data-front-color-wrap]');
          if (colorWrap) colorWrap.hidden = this._s.front.logo === 'logo3';
          this._drawFront();
          this._updateFooter();
        });
      });

      // O replacement toggle (Logo 1 only) — clicking again deselects
      this.querySelectorAll('[data-o-shape]').forEach(btn => {
        btn.addEventListener('click', () => {
          const already = btn.classList.contains('is-selected');
          this.querySelectorAll('[data-o-shape]').forEach(b => b.classList.remove('is-selected'));
          this._s.front.oReplacement = already ? null : btn.dataset.oShape;
          if (!already) btn.classList.add('is-selected');
          this._drawFront();
        });
      });

      // Front thread color
      const frontColorGrid = this.querySelector('[data-front-color]');
      if (frontColorGrid) {
        frontColorGrid.addEventListener('click', e => {
          const btn = e.target.closest('.hc-text-color-btn');
          if (!btn) return;
          frontColorGrid.querySelectorAll('.hc-text-color-btn').forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this._s.front.color = btn.dataset.color;
          this._drawFront();
        });
      }

      // Zone type toggles
      this.querySelectorAll('.hc-toggle-btn').forEach(btn => {
        btn.addEventListener('click', () => this._setZoneType(btn.dataset.zone, btn.dataset.zoneType));
      });

      // Zone text inputs
      this.querySelectorAll('[data-zone-text]').forEach(input => {
        const zone = input.dataset.zoneText;
        input.addEventListener('input', () => {
          this._s.zones[zone].text = input.value;
          const counter = this.querySelector(`[data-char-count="${zone}"]`);
          if (counter) counter.textContent = input.value.length;
          this._drawZone(zone);
        });
        // Enter key: dismiss mobile keyboard, then optionally advance to font picker
        input.addEventListener('keydown', e => {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          input.blur(); // blur first — this is what actually closes the mobile keyboard
        });
      });

      // Font pickers
      this.querySelectorAll('[data-zone-font]').forEach(picker => {
        const zone = picker.dataset.zoneFont;
        picker.querySelectorAll('.hc-font-btn').forEach(btn => {
          btn.addEventListener('click', () => {
            picker.querySelectorAll('.hc-font-btn').forEach(b => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
            this._s.zones[zone].font = btn.dataset.font;
            this._drawZone(zone);
          });
          // Enter on a font button: select it (click fires already) then advance to color grid
          btn.addEventListener('keydown', e => {
            if (e.key !== 'Enter') return;
            const panel = btn.closest('[data-panel="text"]');
            const firstColor = panel?.querySelector('.hc-text-color-btn.is-selected')
                            || panel?.querySelector('.hc-text-color-btn');
            if (firstColor) requestAnimationFrame(() => firstColor.focus());
          });
        });
      });

      // Thread color pickers (delegated since buttons are injected by JS)
      this.querySelectorAll('[data-zone-color]').forEach(picker => {
        const zone = picker.dataset.zoneColor;
        picker.addEventListener('click', e => {
          const btn = e.target.closest('.hc-text-color-btn');
          if (!btn) return;
          picker.querySelectorAll('.hc-text-color-btn').forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this._s.zones[zone].color = btn.dataset.color;
          this._drawZone(zone);
        });
      });

      // Image uploads
      this.querySelectorAll('[data-zone-upload]').forEach(input => {
        input.addEventListener('change', e => {
          const file = e.target.files[0];
          if (file) this._processImage(file, input.dataset.zoneUpload);
        });
      });
      this.querySelectorAll('[data-upload-clear]').forEach(btn => {
        btn.addEventListener('click', () => this._clearImage(btn.dataset.uploadClear));
      });
      this.querySelectorAll('[data-upload-area]').forEach(area => {
        const zone = area.dataset.uploadArea;
        area.addEventListener('dragover', e => { e.preventDefault(); area.classList.add('is-dragover'); });
        area.addEventListener('dragleave', () => area.classList.remove('is-dragover'));
        area.addEventListener('drop', e => {
          e.preventDefault();
          area.classList.remove('is-dragover');
          const file = e.dataTransfer?.files[0];
          if (file?.type.startsWith('image/')) this._processImage(file, zone);
        });
      });

      this.querySelector('#hc-add-to-cart')?.addEventListener('click', () => this._addToCart());

      // Zone selector tabs — jump directly to the target step
      this.querySelectorAll('.hc-zone-sel-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const zone = btn.dataset.zoneBtn;
          const targetStep = ZONE_STEP[zone];
          if (targetStep === undefined) return;
          this._goTo(targetStep);
        });
      });

      // Quantity +/- in review step
      this.querySelector('.hc-qty-wrap')?.addEventListener('click', e => {
        const btn = e.target.closest('.hc-qty-btn');
        if (!btn) return;
        const input = this.querySelector('.hc-qty-input');
        if (!input) return;
        const delta = parseInt(btn.dataset.hcQty, 10);
        input.value = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + delta));
      });
    }

    // ── Open / Close ──────────────────────────────────────────────────────────
    _preloadImages() {
      if (this._imagesPreloaded) return;
      this._imagesPreloaded = true;
      const imgs = window.__hcProductImages;
      if (!imgs) return;
      // Keep refs on instance so GC doesn't drop them before the browser caches
      this._preloadCache = Object.values(imgs).map(({ src }) => {
        const img = new Image();
        img.src = src;
        return img;
      });
    }

    _open() {
      this._preloadImages();
      this._syncFromPDP();
      // Move to body root so position:fixed is never trapped inside a transformed ancestor
      if (this.parentElement !== document.body) document.body.appendChild(this);
      this.classList.add('is-open');
      // Lock background scroll. `overflow:hidden` alone doesn't block touch-scroll
      // on iOS Safari, so pin body in place at its current scroll offset instead.
      this._scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this._scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflowX = 'hidden';
      const s = this._s.step;
      this._switchView(STEP_VIEW[s] || 'front');
      this._highlightZone(s);
      this._updatePreviewPanel(s);
      this._updateProgress();
      this._updateFooter();
      // Redraw canvas for whichever step is currently active
      requestAnimationFrame(() => {
        const s = this._s.step;
        if (s === 1) this._drawFront();
        else if (s === 2) this._drawZone('left');
        else if (s === 3) this._drawZone('right');
        else if (s === 4) this._drawZone('back');
      });

      this._startTour();
    }

    // ── Sync selected variant from the PDP picker into the customizer ─────────
    _syncFromPDP() {
      const productId = this.dataset.productId;
      const picker = document.querySelector(`variant-picker[data-product-id="${productId}"]`)
                  || document.querySelector('variant-selects');
      if (!picker) return;

      const _applyOptions = (options) => {
        options.forEach((val, idx) => {
          if (!val) return;
          this._s.selectedOptions[idx] = val;
          this.querySelectorAll(`.hc-swatch[data-option-index="${idx}"]`).forEach(b =>
            b.classList.toggle('is-selected', b.dataset.value === val)
          );
          const lbl = this.querySelector(`[data-option-val="${idx}"]`);
          if (lbl) lbl.textContent = val;
        });
      };

      // variant-selects (client theme) — read from embedded JSON
      const variantJson = picker.querySelector('[data-selected-variant]');
      if (variantJson) {
        try {
          const variant = JSON.parse(variantJson.textContent);
          if (variant?.options) _applyOptions(variant.options);
        } catch(e) {}
      } else {
        // variant-picker (Horizon/IJDS theme) — read checked radio inputs
        const options = [];
        picker.querySelectorAll('input[type="radio"]:checked, input[type="radio"][data-current-checked="true"]').forEach(input => {
          const idx = parseInt(input.dataset.fieldsetIndex);
          if (!isNaN(idx)) options[idx] = input.value;
        });
        _applyOptions(options);
      }

      this._resolveVariant();
      this._updatePreviewImage();
    }

    _close() {
      this.classList.remove('is-open');
      this.classList.remove('hc-preview-expanded');
      if (this._fsBtnRef) {
        this._fsBtnRef.innerHTML = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="1,5 1,1 5,1"/><polyline points="8,1 12,1 12,5"/><polyline points="12,8 12,12 8,12"/><polyline points="5,12 1,12 1,8"/></svg>`;
        this._fsBtnRef.setAttribute('title', 'Expand preview');
      }
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflowX = '';
      window.scrollTo(0, this._scrollY || 0);
      if (this._resetZoom) this._resetZoom();
    }

    // ── Step routing ──────────────────────────────────────────────────────────
    _goTo(n) {
      this._s.step = n;

      this.querySelectorAll('.hc-step').forEach(panel => {
        panel.hidden = parseInt(panel.dataset.step, 10) !== n;
      });

      const steps = this.querySelector('.hc-steps');
      if (steps) steps.scrollTop = 0;

      this._switchView(STEP_VIEW[n] || 'front');
      this._highlightZone(n);
      this._updatePreviewPanel(n);
      this._updateProgress();
      this._updateFooter();
      if (n === 1) this._drawFront();
      if (n === 2) this._drawZone('left');
      if (n === 3) this._drawZone('right');
      if (n === 4) this._drawZone('back');
      if (n === 5) this._buildReview();
    }

    // ── Update front preview image when variant changes ────────────────────────
    _updatePreviewImage() {
      const variants = window.__hcVariants || [];
      const variant  = variants.find(v => v.id === this._s.variantId);
      const src = variant?.featured_image?.src;
      if (src) {
        const img = this.querySelector('#hv-front');
        if (img) img.src = src;
      }
      // Re-run the homography — the new variant may have its own calibrated
      // corners (PRODUCT_ZONES[handle].variants), and even same-corner
      // variants need this once the new image's naturalWidth is available.
      this._positionStageCanvases();
    }

    // ── Load back image from product images ───────────────────────────────────
    _loadBackImage() {
      const img = this.querySelector('#hv-back');
      if (!img || img.src) return;
      const images = window.__hcProductImages || [];
      const back = images.find(i => /back/i.test(i.src));
      if (back) img.src = back.src;
      else {
        // Fall back to front image
        const front = this.querySelector('#hv-front');
        if (front?.src) img.src = front.src;
      }
    }

    // ── Progress ──────────────────────────────────────────────────────────────
    _updateProgress() {
      const sub = this.querySelector('.hc-step-subtitle');
      if (sub) sub.textContent = SUBTITLES[this._s.step] || '';
      const ctr = this.querySelector('.hc-step-counter');
      if (ctr) ctr.textContent = '';
    }

    // ── Update persistent footer: step counter, progress, Back/Next label ────
    _updateFooter() {
      const n    = this._s.step;
      const last = STEPS.length - 1;

      const label = this.querySelector('.hc-footer-step-label');
      if (label) label.textContent = `STEP ${n + 1} OF ${STEPS.length}`;

      this.querySelectorAll('.hc-progress-seg').forEach((seg, i) => {
        seg.classList.toggle('is-filled', i <= n);
      });

      const back = this.querySelector('.hc-btn-back');
      if (back) back.disabled = n === 0;

      const next = this.querySelector('.hc-btn-next');
      if (next) next.textContent = n === last ? 'Add to Cart' : 'Next →';

      this._syncDoneBadges();
    }

    // ── Hide disabled zones and renumber zone selector tabs ───────────────────
    _applyZoneConfig() {
      const ZONE_TO_STEP = { front: 1, left: 2, right: 3, back: 4 };
      Object.entries(ZONE_TO_STEP).forEach(([zone, stepNum]) => {
        if (this._enabledZones.has(zone)) return;
        const step = this.querySelector(`.hc-step[data-step="${stepNum}"]`);
        if (step) step.hidden = true;
        const tab = this.querySelector(`[data-zone-btn="${zone}"]`);
        if (tab) tab.hidden = true;
      });
      // Renumber visible zone selector tabs sequentially
      let n = 1;
      this.querySelectorAll('.hc-zone-sel-btn:not([hidden])').forEach(tab => {
        const numEl = tab.querySelector('.hc-zsb-num');
        if (numEl) numEl.textContent = n++;
      });
    }

    // ── Find the next step that is not disabled ───────────────────────────────
    _nextEnabledStep(from) {
      const STEP_TO_ZONE = { 1: 'front', 2: 'left', 3: 'right', 4: 'back' };
      for (let n = from; n < STEPS.length; n++) {
        const zone = STEP_TO_ZONE[n];
        if (!zone || this._enabledZones.has(zone)) return n;
      }
      return STEPS.length - 1;
    }

    // ── Find the previous step that is not disabled ───────────────────────────
    _prevEnabledStep(from) {
      const STEP_TO_ZONE = { 1: 'front', 2: 'left', 3: 'right', 4: 'back' };
      for (let n = from; n >= 0; n--) {
        const zone = STEP_TO_ZONE[n];
        if (!zone || this._enabledZones.has(zone)) return n;
      }
      return 0;
    }

    // Resolve PRODUCT_ZONES for the current product/variant. A variant-specific
    // override (keyed by variant ID under `variants`) wins over the handle's
    // base calibration — some color variants use a different product photo
    // and need their own corners.
    _zonesForVariant() {
      const handle = this.dataset.productHandle;
      const base = PRODUCT_ZONES[handle] || PRODUCT_ZONES['_default'] || {};
      const override = this._s.variantId && base.variants ? base.variants[this._s.variantId] : null;
      if (!override) return base;
      const merged = { ...base, ...override };
      delete merged.variants;
      return merged;
    }

    // ── Calibration tool — call from console: hc._injectCalibrationTool('front') ─
    // Requires Fabric.js v7 loaded as `window.fabric` before calling this
    // (load it yourself, e.g. <script src="https://cdn.jsdelivr.net/npm/fabric@7.4.0/dist/index.min.js">).
    // Renders the zone quad as a fabric.Polygon: drag the shape to move it,
    // drag a corner handle to scale, drag the rotate handle to spin it, or
    // drag any yellow vertex dot to skew a single corner for perspective —
    // all on the same object. Live canvas preview updates as you edit.
    _injectCalibrationTool(zone = 'front') {
      const stage = this.querySelector('.hc-hat-stage');
      if (!stage) return console.error('stage not found');
      if (typeof fabric === 'undefined') return console.error('Fabric.js not loaded — load it as window.fabric before calling this (see comment above _injectCalibrationTool).');

      this._hcCalFabric?.dispose();
      this._hcCalFabric = null;
      document.getElementById('_hcCal')?.remove();
      stage.querySelectorAll('._hcCalBtn').forEach(b => b.remove());

      const img = stage.querySelector('.hat-view.is-visible') || stage.querySelector('.hat-view');
      if (!img?.naturalWidth) return console.error('image not loaded yet');

      // Compute rendered image rect inside stage (object-fit:contain)
      const sw = stage.offsetWidth, sh = stage.offsetHeight;
      const aspect = img.naturalWidth / img.naturalHeight;
      let rx, ry, rw, rh;
      if (aspect > sw / sh) { rw = sw; rh = sw / aspect; rx = 0; ry = (sh - rh) / 2; }
      else                  { rh = sh; rw = sh * aspect; rx = (sw - rw) / 2; ry = 0; }
      const IR = { rx, ry, rw, rh, sw, sh };
      window._calImgRect  = IR;

      // Seed corners from current PRODUCT_ZONES (new corners format or legacy rect)
      const zones  = this._zonesForVariant();
      const pos    = zones[zone] || {};
      const rawCorners = pos.corners || _legacyToCorners(pos.left !== undefined ? pos : { left: 20, top: 30, width: 40, height: 35 });
      const seedPoints = rawCorners.map(([px, py]) => ({
        x: rx + px / 100 * rw,
        y: ry + py / 100 * rh,
      }));

      const canvasEl = document.createElement('canvas');
      canvasEl.id = '_hcCal';
      stage.appendChild(canvasEl);

      const fc = new fabric.Canvas(canvasEl, {
        width: sw, height: sh,
        selection: false,
        backgroundColor: 'transparent',
      });
      this._hcCalFabric = fc;
      Object.assign(fc.wrapperEl.style, { position: 'absolute', inset: '0', zIndex: 9999 });

      // TL, TR, BR, BL — order must match PRODUCT_ZONES `corners` and _logCalibration.
      const makePoly = points => {
        const p = new fabric.Polygon(points, {
          fill: 'rgba(255,255,0,0.07)',
          stroke: '#ff0',
          strokeWidth: 1.5,
          strokeDashArray: [5, 3],
          strokeUniform: true,
          cornerColor: '#ff0',
          cornerStrokeColor: '#222',
          transparentCorners: false,
          cornerStyle: 'circle',
          hasBorders: false,
        });
        // Merge in one draggable control per vertex (p0..p3) alongside the
        // default corner-scale + rotate (mtr) controls, instead of replacing
        // them — gives move/scale/rotate/skew all on the same object. For an
        // unrotated/unskewed quad the vertex sits exactly on top of its
        // bounding-box scale handle, so the two controls would occupy the
        // same pixel and only one would be reachable. createPolyControls'
        // vertex controls use their own positionHandler (based on the actual
        // point coordinates) that ignores Control's offsetX/offsetY — that
        // mechanism only exists on the generic base positionHandler used by
        // tl/tr/etc. — so nudge them apart by wrapping positionHandler to
        // shift its result a few px toward the shape interior instead.
        const polyControls = fabric.controlsUtils.createPolyControls(p, { sizeX: 9, sizeY: 9 });
        Object.values(polyControls).forEach(c => {
          const basePositionHandler = c.positionHandler;
          c.positionHandler = function (dim, finalMatrix, obj) {
            return basePositionHandler.call(this, dim, finalMatrix, obj).add(new fabric.Point(8, 8));
          };
        });
        p.controls = { ...p.controls, ...polyControls };
        return p;
      };

      let poly = makePoly(seedPoints);
      fc.add(poly);
      fc.setActiveObject(poly);

      // Absolute stage-px corners for the polygon's current transform.
      const currentCorners = () => poly.points.map(pt => {
        const abs = new fabric.Point(pt).subtract(poly.pathOffset).transform(poly.calcTransformMatrix());
        return { x: abs.x, y: abs.y };
      });

      // Fabric re-renders on every kind of edit — move, scale, rotate, vertex
      // drag, and a programmatic reset — so this one hook keeps the stage
      // canvas preview and window._calCorners in sync with all of them.
      fc.on('after:render', () => {
        window._calCorners = currentCorners();
        this._applyCalToCanvas(zone, window._calCorners, IR);
      });
      fc.requestRenderAll();

      // Reset button — snaps the quad back to an unskewed rectangle matching
      // the 220×160 content-canvas aspect ratio (same canvas every zone's
      // text/logo is drawn on, see _drawFrontNow/_drawZone + _mirrorToStage),
      // centered in the image.
      const resetBtn = document.createElement('button');
      resetBtn.className = '_hcCalBtn';
      resetBtn.textContent = 'Reset ↺';
      Object.assign(resetBtn.style, {
        position: 'absolute', bottom: '8px', right: '110px', zIndex: 10000,
        background: '#ff0', color: '#000', border: 'none', borderRadius: '6px',
        padding: '6px 12px', fontSize: '11px', fontWeight: '700', cursor: 'pointer',
        fontFamily: 'monospace',
      });
      resetBtn.addEventListener('click', () => {
        const CONTENT_ASPECT = 220 / 160; // width / height of the source content canvas
        const widthPct  = 36;
        const heightPct = widthPct / CONTENT_ASPECT;
        const halfW = widthPct / 2, halfH = heightPct / 2;
        const pctCorners = [
          [50 - halfW, 50 - halfH], // TL
          [50 + halfW, 50 - halfH], // TR
          [50 + halfW, 50 + halfH], // BR
          [50 - halfW, 50 + halfH], // BL
        ];
        const resetPoints = pctCorners.map(([px, py]) => ({
          x: rx + px / 100 * rw,
          y: ry + py / 100 * rh,
        }));
        // Swap in a fresh polygon rather than mutating points/scale/angle in
        // place — matches how the initial seed is built, so it can't drift
        // out of sync with the object's internal pathOffset/bbox bookkeeping.
        fc.remove(poly);
        poly = makePoly(resetPoints);
        fc.add(poly);
        fc.setActiveObject(poly);
        fc.requestRenderAll();
      });
      stage.appendChild(resetBtn);

      // Apply & Log button
      const applyBtn = document.createElement('button');
      applyBtn.className = '_hcCalBtn';
      applyBtn.textContent = 'Apply & Log ✓';
      Object.assign(applyBtn.style, {
        position: 'absolute', bottom: '8px', right: '8px', zIndex: 10000,
        background: '#ff0', color: '#000', border: 'none', borderRadius: '6px',
        padding: '6px 12px', fontSize: '11px', fontWeight: '700', cursor: 'pointer',
        fontFamily: 'monospace',
      });
      applyBtn.addEventListener('click', () => this._logCalibration(zone, IR));
      stage.appendChild(applyBtn);

      console.log(`Calibration tool ready for zone "${zone}" on "${this.dataset.productHandle || '_default'}"`);
      console.log(`Image: ${rw.toFixed(0)}×${rh.toFixed(0)} at (${rx.toFixed(0)}, ${ry.toFixed(0)}) in ${sw}×${sh} stage`);
      console.log('Drag to move, corner handles to scale, rotate handle to spin, or drag a yellow vertex dot to skew. Then click "Apply & Log".');
    }

    // Live-apply dragged corners to the stage canvas so the preview tracks the quad
    _applyCalToCanvas(zone, cs, IR) {
      const { sw, sh } = IR;
      const stagePx = cs.map(c => [c.x, c.y]);

      const xs = stagePx.map(c => c[0]), ys = stagePx.map(c => c[1]);
      const bx = Math.min(...xs), by = Math.min(...ys);
      const bw = Math.max(...xs) - bx,  bh = Math.max(...ys) - by;
      if (bw < 2 || bh < 2) return;

      const relC = stagePx.map(c => [c[0] - bx, c[1] - by]);
      const H    = _computeHomography([[0, 0], [bw, 0], [bw, bh], [0, bh]], relC);
      const m3d  = _homographyToCSS(H);

      const applyEl = el => {
        if (!el) return;
        el.style.left            = (bx / sw * 100) + '%';
        el.style.top             = (by / sh * 100) + '%';
        el.style.width           = (bw / sw * 100) + '%';
        el.style.height          = (bh / sh * 100) + '%';
        el.style.transformOrigin = '0 0';
        el.style.transform       = m3d;
      };

      const canvas  = this.querySelector(`[data-stage-canvas="${zone}"]`);
      const overlay = this.querySelector(`[data-zone-overlay="${zone}"]`);
      if (canvas) { applyEl(canvas); canvas.removeAttribute('hidden'); }
      applyEl(overlay);
    }

    // Log calibrated corners to console in PRODUCT_ZONES paste-ready format
    _logCalibration(zone, IR) {
      const cs = window._calCorners;
      if (!cs) return;
      const { rx, ry, rw, rh, sw, sh } = IR;

      // Convert stage-px corners to image-% (what PRODUCT_ZONES stores)
      const corners = cs.map(c => [
        +((c.x - rx) / rw * 100).toFixed(1),
        +((c.y - ry) / rh * 100).toFixed(1),
      ]);

      const handle     = this.dataset.productHandle || '_default';
      const variantId  = this._s.variantId;
      const cornersStr = corners.map(c => `[${c[0]}, ${c[1]}]`).join(', ');
      const entry      = `{ corners: [${cornersStr}] }`;

      console.log('=== HAT ZONE CALIBRATION ===');
      if (variantId) {
        console.log(`Variant ${variantId} — nest under handle's "variants" map:`);
        console.log(`'${handle}': { variants: { ${variantId}: { ${zone}: ${entry} } } }`);
      } else {
        console.log(`'${handle}': { ${zone}: ${entry} }`);
      }
      console.log(`Screen: ${window.screen.width}×${window.screen.height}  DPR=${window.devicePixelRatio}  Stage: ${sw}×${sh}  Image: ${rw.toFixed(0)}×${rh.toFixed(0)} @(${rx.toFixed(0)},${ry.toFixed(0)})`);
      console.log('Corners (stage px):', JSON.stringify(cs.map(c => ({ x: Math.round(c.x), y: Math.round(c.y) }))));
    }

    // ── Preview controls bar — zone toggle, reset zoom, fullscreen ───────────
    // Injected into .hc-hat-preview (not .hc-hat-stage) so the bar stays fixed
    // in place and is never affected by the stage zoom/pan transform.
    _initOverlayToggle() {
      const preview = this.querySelector('.hc-hat-preview');
      if (!preview) return;

      const _btn = (cls, title, aria, html) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = `hc-preview-ctrl-btn ${cls}`;
        b.setAttribute('title', title);
        b.setAttribute('aria-label', aria);
        b.innerHTML = html;
        return b;
      };

      const GRID_SVG    = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="1" width="4.5" height="4.5" rx="1"/><rect x="7.5" y="1" width="4.5" height="4.5" rx="1"/><rect x="1" y="7.5" width="4.5" height="4.5" rx="1"/><rect x="7.5" y="7.5" width="4.5" height="4.5" rx="1"/></svg>`;
      const EXPAND_SVG  = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="1,5 1,1 5,1"/><polyline points="8,1 12,1 12,5"/><polyline points="12,8 12,12 8,12"/><polyline points="5,12 1,12 1,8"/></svg>`;
      const COLLAPSE_SVG = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="1,4 4,4 4,1"/><polyline points="12,4 9,4 9,1"/><polyline points="9,12 9,9 12,9"/><polyline points="4,12 4,9 1,9"/></svg>`;

      // Left: zone overlay toggle
      const toggle = _btn('hc-overlay-toggle', 'Hide zone guides', 'Toggle zone guides', GRID_SVG);
      toggle.addEventListener('click', () => {
        const hiding = this.classList.toggle('hc-zones-hidden');
        toggle.classList.toggle('is-off', hiding);
        toggle.setAttribute('title', hiding ? 'Show zone guides' : 'Hide zone guides');
      });

      // Center: view label badge (Front / Back)
      const badge = document.createElement('span');
      badge.className = 'hc-zone-badge';

      // Right: zoom button + popup + fullscreen
      const right = document.createElement('div');
      right.className = 'hc-preview-ctrl-right';

      const ZOOM_SVG = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="5.5" cy="5.5" r="4"/><line x1="5.5" y1="3.5" x2="5.5" y2="7.5"/><line x1="3.5" y1="5.5" x2="7.5" y2="5.5"/><line x1="8.7" y1="8.7" x2="12.5" y2="12.5"/></svg>`;

      const zoomWrap = document.createElement('div');
      zoomWrap.className = 'hc-zoom-wrap';

      const zoomBtn = _btn('hc-zoom-btn', 'Zoom', 'Zoom preview', ZOOM_SVG);

      const popup = document.createElement('div');
      popup.className = 'hc-zoom-popup';
      popup.setAttribute('role', 'menu');
      popup.hidden = true;

      [{ label: '1×', scale: 1 }, { label: '1.5×', scale: 1.5 }, { label: '3×', scale: 3 }, { label: '6×', scale: 6 }].forEach(({ label, scale }) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'hc-zoom-popup-btn';
        b.textContent = label;
        b.setAttribute('role', 'menuitem');
        if (scale === 1) { b.hidden = true; this._zoomReset1xBtn = b; }
        b.addEventListener('click', () => { if (this._setZoom) this._setZoom(scale); popup.hidden = true; });
        popup.appendChild(b);
      });

      zoomBtn.addEventListener('click', e => { e.stopPropagation(); popup.hidden = !popup.hidden; });
      document.addEventListener('click', () => { popup.hidden = true; });

      zoomWrap.appendChild(popup);
      zoomWrap.appendChild(zoomBtn);

      const fsBtn = _btn('hc-fullscreen-btn', 'Expand preview', 'Toggle full-screen preview', EXPAND_SVG);
      this._fsBtnRef = fsBtn;
      fsBtn.addEventListener('click', () => {
        const expanded = this.classList.toggle('hc-preview-expanded');
        fsBtn.innerHTML  = expanded ? COLLAPSE_SVG : EXPAND_SVG;
        fsBtn.setAttribute('title', expanded ? 'Collapse preview' : 'Expand preview');
        // Redraw after layout settles so _hdCanvas reads the new canvas dimensions
        requestAnimationFrame(() => {
          const s = this._s.step;
          if (s === 1) this._drawFront();
          else if (s === 2) this._drawZone('left');
          else if (s === 3) this._drawZone('right');
          else if (s === 4) this._drawZone('back');
        });
      });

      right.appendChild(zoomWrap);
      right.appendChild(fsBtn);

      const bar = document.createElement('div');
      bar.className = 'hc-preview-controls';
      // "Hide zone guides" toggle hidden for now — going live without it, restore by uncommenting.
      // bar.appendChild(toggle);
      bar.appendChild(badge);
      bar.appendChild(right);

      preview.appendChild(bar);
    }

    // ── Zoom and pan on the hat preview ───────────────────────────────────────
    _initZoom() {
      const stage   = this.querySelector('.hc-hat-stage');
      const preview = this.querySelector('.hc-hat-preview');
      if (!stage || !preview) return;
      const { reset, setZoom } = this._makeZoomable(preview, stage, {
        statusBtn: this._zoomReset1xBtn,
        injectResetBtn: true,
      });
      this._resetZoom = reset;
      this._setZoom   = setZoom;
    }

    // ── Zoom on left-pane canvas previews ─────────────────────────────────────
    _initCanvasZoom() {
      this.querySelectorAll('.hc-canvas-wrap').forEach(wrap => {
        const canvas = wrap.querySelector('canvas');
        if (!canvas) return;
        this._makeZoomable(wrap, canvas, { injectResetBtn: true });
      });
    }

    // ── Shared zoom/pan engine ─────────────────────────────────────────────────
    // container: event target + bounds element
    // target:    element receiving the CSS transform
    // opts.statusBtn:      toggled hidden/visible based on zoom level
    // opts.injectResetBtn: inject the overlay magnifying-glass-minus button
    _makeZoomable(container, target, opts = {}) {
      const { statusBtn = null, injectResetBtn = false } = opts;
      const MINUS_SVG = `<svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="5.5" cy="5.5" r="4"/><line x1="3.5" y1="5.5" x2="7.5" y2="5.5"/><line x1="8.7" y1="8.7" x2="12.5" y2="12.5"/></svg>`;

      let resetBtn = null;
      if (injectResetBtn) {
        resetBtn = document.createElement('button');
        resetBtn.type = 'button';
        resetBtn.className = 'hc-canvas-reset-btn';
        resetBtn.setAttribute('aria-label', 'Reset zoom');
        resetBtn.innerHTML = MINUS_SVG;
        container.appendChild(resetBtn);
      }

      const z = { s: 1, tx: 0, ty: 0 };
      const MAX_SCALE = 6;
      let _pinch = null, _pan = null, _mouseDrag = null, _lastTap = 0;

      const apply = () => {
        target.style.transform = `translate(${z.tx}px,${z.ty}px) scale(${z.s})`;
        if (!_mouseDrag) container.style.cursor = z.s > 1 ? 'grab' : '';
        if (statusBtn) statusBtn.hidden = z.s < 1.1;
        if (resetBtn) resetBtn.classList.toggle('is-visible', z.s > 1.1);
      };

      const clamp = () => {
        if (z.s <= 1) { z.tx = 0; z.ty = 0; return; }
        const maxX = container.offsetWidth  * (z.s - 1) / 2;
        const maxY = container.offsetHeight * (z.s - 1) / 2;
        z.tx = Math.max(-maxX, Math.min(maxX, z.tx));
        z.ty = Math.max(-maxY, Math.min(maxY, z.ty));
      };

      const setZoom = (targetScale, pivotX = 0, pivotY = 0) => {
        if (targetScale <= 1) {
          z.s = 1; z.tx = 0; z.ty = 0;
        } else {
          const ratio = targetScale / z.s;
          z.tx = pivotX - (pivotX - z.tx) * ratio;
          z.ty = pivotY - (pivotY - z.ty) * ratio;
          z.s  = Math.min(MAX_SCALE, targetScale);
          clamp();
        }
        apply();
      };

      const reset = () => setZoom(1);

      if (resetBtn) resetBtn.addEventListener('click', e => { e.stopPropagation(); reset(); });

      const ptDist = (a, b) => Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
      const ptMid  = (a, b) => ({ x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 });

      container.addEventListener('wheel', e => {
        if (e.target.closest('.hc-preview-ctrl-btn, .hc-zoom-popup, .hc-canvas-reset-btn')) return;
        e.preventDefault();
        const r  = container.getBoundingClientRect();
        const px = e.clientX - r.left - r.width  / 2;
        const py = e.clientY - r.top  - r.height / 2;
        const ns = Math.min(MAX_SCALE, Math.max(1, z.s * (e.deltaY > 0 ? 0.9 : 1.1)));
        if (ns === z.s) return;
        const ratio = ns / z.s;
        z.tx = px - (px - z.tx) * ratio;
        z.ty = py - (py - z.ty) * ratio;
        z.s  = ns;
        clamp();
        apply();
      }, { passive: false });

      container.addEventListener('mousedown', e => {
        if (e.target.closest('.hc-preview-ctrl-btn, .hc-zoom-popup, .hc-canvas-reset-btn')) return;
        if (z.s <= 1) return;
        e.preventDefault();
        _mouseDrag = { x0: e.clientX, y0: e.clientY, tx0: z.tx, ty0: z.ty };
        container.style.cursor = 'grabbing';
      });
      window.addEventListener('mousemove', e => {
        if (!_mouseDrag) return;
        z.tx = _mouseDrag.tx0 + (e.clientX - _mouseDrag.x0);
        z.ty = _mouseDrag.ty0 + (e.clientY - _mouseDrag.y0);
        clamp();
        target.style.transform = `translate(${z.tx}px,${z.ty}px) scale(${z.s})`;
      });
      window.addEventListener('mouseup', () => {
        if (!_mouseDrag) return;
        _mouseDrag = null;
        container.style.cursor = z.s > 1 ? 'grab' : '';
      });

      container.addEventListener('dblclick', e => {
        if (e.target.closest('.hc-preview-ctrl-btn, .hc-zoom-popup, .hc-canvas-reset-btn')) return;
        reset();
      });

      container.addEventListener('touchstart', e => {
        if (e.target.closest('.hc-preview-ctrl-btn, .hc-canvas-reset-btn')) return;
        if (e.touches.length === 2) {
          e.preventDefault();
          _pan = null;
          const r = container.getBoundingClientRect();
          const m = ptMid(e.touches[0], e.touches[1]);
          _pinch = {
            d0: ptDist(e.touches[0], e.touches[1]),
            s0: z.s, tx0: z.tx, ty0: z.ty,
            dx: m.x - (r.left + r.width  / 2),
            dy: m.y - (r.top  + r.height / 2),
          };
        } else if (e.touches.length === 1) {
          const now = Date.now();
          if (now - _lastTap < 300) { e.preventDefault(); reset(); _lastTap = 0; return; }
          _lastTap = now;
          if (z.s > 1) {
            e.preventDefault();
            _pan = { x0: e.touches[0].clientX, y0: e.touches[0].clientY, tx0: z.tx, ty0: z.ty };
          }
        }
      }, { passive: false });

      container.addEventListener('touchmove', e => {
        if (e.touches.length === 2 && _pinch) {
          e.preventDefault();
          const ns    = Math.min(MAX_SCALE, Math.max(1, _pinch.s0 * ptDist(e.touches[0], e.touches[1]) / _pinch.d0));
          const ratio = ns / _pinch.s0;
          z.s  = ns;
          z.tx = _pinch.dx - (_pinch.dx - _pinch.tx0) * ratio;
          z.ty = _pinch.dy - (_pinch.dy - _pinch.ty0) * ratio;
          clamp();
          apply();
        } else if (e.touches.length === 1 && _pan && z.s > 1) {
          e.preventDefault();
          z.tx = _pan.tx0 + (e.touches[0].clientX - _pan.x0);
          z.ty = _pan.ty0 + (e.touches[0].clientY - _pan.y0);
          clamp();
          apply();
        }
      }, { passive: false });

      container.addEventListener('touchend', e => {
        if (e.touches.length < 2) _pinch = null;
        if (e.touches.length === 0) { _pan = null; if (z.s < 1.1) reset(); }
      });

      return { reset, setZoom };
    }

    // ── First-time onboarding tour (Driver.js, lazy-loaded) ───────────────────
    _loadDriverJs(cb) {
      if (typeof window.driver === 'function') { cb(); return; }
      const link  = document.createElement('link');
      link.rel    = 'stylesheet';
      link.href   = 'https://cdn.jsdelivr.net/npm/driver.js@1/dist/driver.css';
      document.head.appendChild(link);
      const scr   = document.createElement('script');
      scr.src     = 'https://cdn.jsdelivr.net/npm/driver.js@1/dist/driver.js.iife.js';
      scr.onload  = cb;
      document.head.appendChild(scr);
    }

    _startTour() {
      if (localStorage.getItem('ijds_hc_toured')) return;
      this._loadDriverJs(() => {
        if (typeof window.driver !== 'function') return;
        const self = this;
        const tour = window.driver({
          animate: true,
          overlayOpacity: 0.5,
          popoverClass: 'hc-driver-popover',
          onDestroyStarted: () => {
            localStorage.setItem('ijds_hc_toured', '1');
            tour.destroy();
          },
          steps: [
            {
              element: self.querySelector('.hc-step[data-step="0"]'),
              popover: {
                title: 'Start with Style',
                description: 'Choose your hat color and size. This determines which embroidery options are available.',
                side: 'right', align: 'start',
              },
            },
            {
              element: self.querySelector('.hc-preview'),
              popover: {
                title: 'Live Preview',
                description: 'Your design updates here in real time as you make selections.',
                side: 'left', align: 'center',
              },
            },
            {
              element: self.querySelector('.hc-zone-selector'),
              popover: {
                title: 'Jump Between Zones',
                description: 'Tap any tab to jump directly to that section. A green badge means you\'ve added something to that zone.',
                side: 'bottom', align: 'center',
              },
            },
          ],
        });
        setTimeout(() => tour.drive(), 500);
      });
    }

    // ── Sync done badges on accordion headers and zone selector tabs ─────────
    _syncDoneBadges() {
      const { variantId, front, zones } = this._s;
      const isDone = {
        0: !!variantId,
        1: !!front.logo,
        2: zones.left.type  !== 'none',
        3: zones.right.type !== 'none',
        4: zones.back.type  !== 'none',
      };
      const isReady = isDone[0] && isDone[1];

      this.querySelectorAll('.hc-step').forEach(panel => {
        const n = parseInt(panel.dataset.step, 10);
        panel.classList.toggle('is-done', !!isDone[n]);
      });
      const activeStep = this._s.step;
      this.querySelectorAll('.hc-zone-sel-btn').forEach(btn => {
        const n = ZONE_STEP[btn.dataset.zoneBtn];
        if (n === undefined) return;
        btn.classList.toggle('is-active', n === activeStep);
        btn.classList.toggle('is-done', !!isDone[n] && n !== activeStep);
        if (btn.dataset.zoneBtn === 'review') btn.classList.toggle('is-ready', isReady);
      });

      this.querySelector('.hc-ready-chip')?.toggleAttribute('hidden', !isReady);
    }

    // ── Zone type toggle ──────────────────────────────────────────────────────
    _setZoneType(zone, type) {
      this._s.zones[zone].type = type;
      this.querySelectorAll(`.hc-toggle-btn[data-zone="${zone}"]`).forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.zoneType === type);
      });
      this.querySelectorAll(`[data-panel][data-zone="${zone}"]`).forEach(panel => {
        panel.hidden = panel.dataset.panel !== type;
      });
      this._updateZonePrice(zone);
      this._drawZone(zone);
      this._syncDoneBadges();
    }

    // ── Step-title price hint — mirrors ADD_ON_VARIANTS so there are no
    // surprises at checkout: text +$6.99, image upload +$9.99, none = free.
    _updateZonePrice(zone) {
      const priceEl = this.querySelector(`[data-step-price="${zone}"]`);
      if (!priceEl) return;
      const type = this._s.zones[zone].type;
      priceEl.textContent = type === 'text' ? '+$6.99' : type === 'image' ? '+$9.99' : '';
    }

    // ── Treat "Add Text"/"Upload Image" left empty as if "Leave Blank" had
    // been chosen, so leaving Next without entering anything doesn't charge
    // an add-on for a panel with nothing in it.
    _normalizeZoneIfEmpty(zone) {
      const z = this._s.zones[zone];
      if (!z) return;
      const isEmptyText  = z.type === 'text'  && !z.text.trim();
      const isEmptyImage = z.type === 'image' && !z.image;
      if (isEmptyText || isEmptyImage) this._setZoneType(zone, 'none');
    }

    // ── Variant resolution ────────────────────────────────────────────────────
    _resolveVariant() {
      const variants = window.__hcVariants;
      if (!variants) return;
      const match = variants.find(v =>
        Object.entries(this._s.selectedOptions).every(([idx, val]) => v[`option${Number(idx) + 1}`] === val)
      );
      this._s.variantId = match?.id ?? null;
    }

    // ── Selected hat color hex ────────────────────────────────────────────────
    _hatColor() {
      const sel = this.querySelector('.hc-swatches--color .hc-swatch.is-selected');
      return sel?.dataset.hex || '#1c1c1c';
    }

    // ── HiDPI canvas setup ────────────────────────────────────────────────────
    _hdCanvas(canvas) {
      const dpr  = window.devicePixelRatio || 1;
      const cssW = canvas.offsetWidth  || parseInt(canvas.getAttribute('width'),  10) || 220;
      const cssH = canvas.offsetHeight || parseInt(canvas.getAttribute('height'), 10) || 160;
      const bmpW = Math.round(cssW * dpr);
      const bmpH = Math.round(cssH * dpr);
      if (canvas.width !== bmpW || canvas.height !== bmpH) {
        canvas.width  = bmpW;
        canvas.height = bmpH;
      }
      const ctx = canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return { ctx, W: cssW, H: cssH };
    }

    // ── Canvas: front logo ────────────────────────────────────────────────────
    _drawFront() {
      const canvas = this.querySelector('[data-hc-canvas="front"]');
      if (!canvas) return;
      // Ensure both front fonts are loaded before drawing — canvas falls back to Impact if not ready
      Promise.all([
        document.fonts.load('72px Anton'),
        document.fonts.load("72px 'Full Block'"),
      ]).then(() => this._drawFrontNow());
    }

    _drawFrontNow() {
      const canvas = this.querySelector('[data-hc-canvas="front"]');
      if (!canvas) return;
      const { ctx, W, H } = this._hdCanvas(canvas);
      const { logo, oReplacement, color } = this._s.front;

      ctx.clearRect(0, 0, W, H);

      // Reset mini-preview background to default (will be overridden below for light colors)
      const _canvasWrap = this.querySelector('.hc-canvas-wrap');

      if (!logo) {
        if (_canvasWrap) _canvasWrap.style.background = '';
        ctx.fillStyle = '#bbb'; ctx.font = '10px Arial';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText('Choose a logo', W / 2, H / 2);
        this._badge('front', '');
        this._clearStageCanvas('front');
        return;
      }

      const fill  = color || '#000000';
      const ANTON = 'Anton, Impact, sans-serif';

      // Adaptive mini-preview background only — canvas stays transparent so the hat stage is unaffected
      const _r = parseInt(fill.slice(1, 3), 16);
      const _g = parseInt(fill.slice(3, 5), 16);
      const _b = parseInt(fill.slice(5, 7), 16);
      if (_canvasWrap) _canvasWrap.style.background = (0.2126 * _r / 255 + 0.7152 * _g / 255 + 0.0722 * _b / 255) > 0.4 ? '#2a2a2a' : '';

      if (logo === 'logo1') {
        // IT JUST      ← line 1
        // DOESN'T STOP ← line 2 (wider line drives font size; O may be replaced)
        ctx.textBaseline = 'alphabetic';

        // Size so "DOESN'T STOP" fills 97% of width — stable across oReplacement toggle
        let fs = 72;
        const targetW = W * 0.97;
        while (fs > 10) {
          ctx.font = `${fs}px ${ANTON}`;
          const ch = ctx.measureText('H').actualBoundingBoxAscent || fs * 0.80;
          const ow = Math.max(ctx.measureText('O').width, ch + Math.max(2, fs * 0.05) + Math.ceil(fs * 0.1));
          if (ctx.measureText("DOESN'T ST").width + ow + ctx.measureText('P').width <= targetW) break;
          fs--;
        }

        const lineH = fs * 1.1;

        // Center the two-line block using actual measured ascent/descent
        ctx.font = `${fs}px ${ANTON}`;
        const asc  = ctx.measureText('IT JUST').actualBoundingBoxAscent  || fs * 0.72;
        const desc = ctx.measureText("DOESN'T STOP").actualBoundingBoxDescent || fs * 0.1;
        const blockH = asc + lineH + desc;
        const topY   = H / 2 - blockH / 2 + asc;

        ctx.fillStyle = fill;
        ctx.textAlign = 'center';

        // Heart/Octagon O-replacements render slightly larger than the glyph
        // they stand in for and can breach the stage's calibrated bounding
        // box — shrink the whole logo 2% around center to keep it inside.
        if (oReplacement) {
          ctx.save();
          ctx.translate(W / 2, H / 2);
          ctx.scale(0.98, 0.98);
          ctx.translate(-W / 2, -H / 2);
        }

        // Line 1: IT JUST
        this._drawEmbroidered(ctx, 'IT JUST', W / 2, topY, fill);

        // Line 2: DOESN'T STOP (or DOESN'T ST + shape + P)
        const line2Y = topY + lineH;
        if (!oReplacement) {
          this._drawEmbroidered(ctx, "DOESN'T STOP", W / 2, line2Y, fill);
        } else {
          // Measure to splice shape inline as the O in STOP
          ctx.font = `${fs}px ${ANTON}`;
          const capH    = ctx.measureText('H').actualBoundingBoxAscent || fs * 0.80;
          const shapeR  = capH / 2.9;
          const strokeW = Math.max(2, fs * 0.05);
          const prefW   = ctx.measureText("DOESN'T ST").width;
          const oW      = Math.max(ctx.measureText('O').width, capH + strokeW + Math.ceil(fs * 0.1));
          const sufW    = ctx.measureText('P').width;
          const totalLineW = prefW + oW + sufW;
          const startX  = W / 2 - totalLineW / 2;

          ctx.textAlign = 'left';
          this._drawEmbroidered(ctx, "DOESN'T ST", startX, line2Y, fill);

          // Shape replaces the O — embroidery-style outline (shadow → main → highlight, all stroked)
          const shapeY = line2Y - capH / 2;
          const shapeX = startX + prefW + oW / 2;
          const _sr = parseInt(fill.slice(1,3),16), _sg = parseInt(fill.slice(3,5),16), _sb = parseInt(fill.slice(5,7),16);
          const _sd = `rgb(${Math.max(0,_sr-65)},${Math.max(0,_sg-65)},${Math.max(0,_sb-65)})`;
          const _sl = `rgb(${Math.min(255,_sr+80)},${Math.min(255,_sg+80)},${Math.min(255,_sb+80)})`;
          const sw = Math.max(2.5, fs * 0.06);
          // 1. Shadow stroke
          ctx.save(); ctx.translate(1.2, 1.2);
          this._shape(ctx, oReplacement, shapeX, shapeY, shapeR);
          ctx.strokeStyle = _sd; ctx.lineWidth = sw + 0.8; ctx.lineJoin = 'round'; ctx.globalAlpha = 0.5; ctx.stroke();
          ctx.restore();
          // 2. Main stroke
          this._shape(ctx, oReplacement, shapeX, shapeY, shapeR);
          ctx.strokeStyle = fill; ctx.lineWidth = sw; ctx.lineJoin = 'round'; ctx.globalAlpha = 1; ctx.stroke();
          // 3. Highlight sheen
          ctx.save(); ctx.translate(-0.6, -0.8);
          this._shape(ctx, oReplacement, shapeX, shapeY, shapeR);
          ctx.strokeStyle = _sl; ctx.lineWidth = sw * 0.5; ctx.globalAlpha = 0.38; ctx.stroke();
          ctx.restore();
          ctx.globalAlpha = 1;

          this._drawEmbroidered(ctx, 'P', startX + prefW + oW, line2Y, fill);
        }

        if (oReplacement) ctx.restore();

        this._badge('front', oReplacement ? `Signature · ${oReplacement} O` : 'Signature');

      } else if (logo === 'logo2') {
        const BLOCK = "'Full Block', Impact, sans-serif";
        ctx.textBaseline = 'middle';
        ctx.textAlign    = 'center';

        let fs = 120;
        ctx.font = `${fs}px ${BLOCK}`;
        while (ctx.measureText('IJDS').width > W - 8 && fs > 12) {
          fs--;
          ctx.font = `${fs}px ${BLOCK}`;
        }

        this._drawEmbroidered(ctx, 'IJDS', W / 2, H / 2, fill);

        this._badge('front', 'IJDS · Block');

      } else if (logo === 'logo3') {
        ctx.strokeStyle = '#ccc';
        ctx.setLineDash([4, 4]);
        ctx.strokeRect(16, 16, W - 32, H - 32);
        ctx.setLineDash([]);
        ctx.fillStyle = '#aaa'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = '11px Arial';
        ctx.fillText('IJDS Wave Logo', W / 2, H / 2 - 9);
        ctx.font = '9px Arial'; ctx.fillStyle = '#bbb';
        ctx.fillText('(asset coming soon)', W / 2, H / 2 + 9);
        this._badge('front', 'Wave Logo');
      }

      this._mirrorToStage('front', canvas);
    }

    // ── Canvas: zone card ─────────────────────────────────────────────────────
    // Paints both the small sidebar canvas and the big on-stage canvas
    // natively, each at its own resolution (see _paintZoneCanvas), instead of
    // drawing once and stretching a copy into the other size. Stretching a
    // copy either direction is lossy: shrinking the big canvas into the
    // sidebar left the sidebar's content tiny (it only ever filled a thin
    // band of the big canvas's height); stretching the small canvas back up
    // into the big one made the big preview blurry.
    _drawZone(zone) {
      const sideCanvas = this.querySelector(`[data-hc-canvas-side="${zone}"]`);
      const bigCanvas  = this.querySelector(`[data-hc-canvas="${zone}"]`);
      const z          = this._s.zones[zone];
      if (!sideCanvas || !z) return;

      const paintBoth = (img) => {
        this._paintZoneCanvas(sideCanvas, z, img);
        // Big stage canvas renders text 35% smaller than the sidebar — at
        // full size it dwarfed the preview on wide desktop stages.
        if (bigCanvas) this._paintZoneCanvas(bigCanvas, z, img, { scale: 0.65 });
      };

      if (z.type === 'none') {
        paintBoth();
        this._badge(zone, '');
        return;
      }

      if (z.type === 'text') {
        paintBoth();
        this._badge(zone, z.text ? `Text · ${z.font}` : 'Text');
        return;
      }

      if (z.type === 'image') {
        if (!z.image) {
          paintBoth();
          this._badge(zone, 'Image');
          return;
        }
        const img = new Image();
        img.onload = () => paintBoth(img);
        img.src = z.image;
        this._badge(zone, 'Image uploaded');
      }
    }

    // Paints one canvas (sidebar or on-stage) for the given zone state. Called
    // twice per _drawZone() so each canvas renders crisply at its own size.
    // Only clears — does NOT fill an opaque background. _drawEmbroidered()'s
    // highlight layer relies on `source-atop` compositing to clip itself to
    // the text glyphs; filling the whole canvas opaque first defeats that
    // clipping; it'll have something to draw "atop" everywhere, washing its
    // gradient across the entire canvas. The dark backdrop instead comes from
    // CSS (.hc-zone-stage-canvas / .hc-canvas-wrap canvas background).
    _paintZoneCanvas(canvas, z, preloadedImg, opts = {}) {
      // Uniformly scales both the width-fit target and the height-derived
      // max/min font sizes, so the reduction applies whether a given string
      // is width-constrained (long text) or height-constrained (short text
      // that never hit the width cap to begin with).
      const scale = opts.scale ?? 1;
      const { ctx, W: cW, H: cH } = this._hdCanvas(canvas);
      ctx.clearRect(0, 0, cW, cH);

      // Sized relative to this canvas's own height so the fit is correct
      // whether this is the small 160px-tall sidebar canvas or the much
      // taller big on-stage canvas.
      const phFont   = `${Math.max(Math.floor(cH * 0.09 * scale), 14)}px Arial`;
      const fsMax    = Math.max(Math.floor(cH * 0.56 * scale), 24);
      const fsMin    = Math.max(Math.floor(cH * 0.09 * scale), 14);
      const fitWidth = cW * 0.85 * scale;

      if (z.type === 'none') {
        ctx.fillStyle = '#888'; ctx.font = phFont;
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText('Blank', cW / 2, cH / 2);
        return;
      }

      if (z.type === 'text') {
        const family = FONT_MAP[z.font] || FONT_MAP.full_block;
        if (!z.text) {
          const phText = 'Enter text…';
          let fs = fsMax;
          ctx.font = `${fs}px ${family}`;
          while (ctx.measureText(phText).width > fitWidth && fs > fsMin) {
            fs--;
            ctx.font = `${fs}px ${family}`;
          }
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          this._drawEmbroidered(ctx, phText, cW / 2, cH / 2, z.color || '#888888');
          return;
        }
        const zFill = z.color || '#000000';
        let fs = fsMax;
        ctx.font = `bold ${fs}px ${family}`;
        while (ctx.measureText(z.text).width > fitWidth && fs > fsMin) {
          fs--;
          ctx.font = `bold ${fs}px ${family}`;
        }
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        this._drawEmbroidered(ctx, z.text, cW / 2, cH / 2, zFill);
        return;
      }

      if (z.type === 'image') {
        if (!preloadedImg) {
          ctx.fillStyle = '#888'; ctx.font = phFont;
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText('Upload image…', cW / 2, cH / 2);
          return;
        }
        const sc = Math.min(cW / preloadedImg.width, cH / preloadedImg.height) * 0.9;
        ctx.drawImage(
          preloadedImg,
          (cW - preloadedImg.width * sc) / 2,
          (cH - preloadedImg.height * sc) / 2,
          preloadedImg.width * sc,
          preloadedImg.height * sc
        );
      }
    }

    _badge(zone, text) {
      const el = this.querySelector(`[data-hc-badge="${zone}"]`);
      if (el) el.textContent = text;
    }

    // ── Stage canvas overlay (design mirrored onto hat preview image) ─────────
    // Uses a homographic (matrix3d) transform so the overlay has true perspective,
    // not an affine skew approximation.
    _positionStageCanvases() {
      const handle = this.dataset.productHandle;
      const zones  = this._zonesForVariant();
      if (!zones || !Object.keys(zones).length) return;

      const stage = this.querySelector('.hc-hat-stage');
      const img   = stage && stage.querySelector('.hat-view');

      if (img && !img.naturalWidth) {
        img.addEventListener('load', () => this._positionStageCanvases(), { once: true });
        return;
      }

      const sw = stage ? stage.offsetWidth  : 1;
      const sh = stage ? stage.offsetHeight : 1;
      let rx = 0, ry = 0, rw = sw, rh = sh;
      if (img && img.naturalWidth && sw) {
        const aspect = img.naturalWidth / img.naturalHeight;
        if (aspect > sw / sh) { rw = sw; rh = sw / aspect; rx = 0; ry = (sh - rh) / 2; }
        else                  { rh = sh; rw = sh * aspect; rx = (sw - rw) / 2; ry = 0; }
      }

      const activeLogo = this._s.front.logo;
      Object.entries(zones).forEach(([zone, pos]) => {
        // Per-logo front coords: if pos has a logo1/logo2 sub-object and the logo matches, use it
        const resolvedPos = (zone === 'front' && activeLogo && pos[activeLogo]) ? pos[activeLogo] : pos;
        // Convert image-% corners → stage-px, then compute perspective transform
        const rawCorners = resolvedPos.corners || _legacyToCorners(resolvedPos);
        const stagePx = rawCorners.map(([px, py]) => [rx + px / 100 * rw, ry + py / 100 * rh]);

        const xs = stagePx.map(c => c[0]), ys = stagePx.map(c => c[1]);
        const bx = Math.min(...xs), by = Math.min(...ys);
        const bw = Math.max(...xs) - bx,  bh = Math.max(...ys) - by;
        if (bw < 2 || bh < 2) return;

        // Corners relative to bounding-box origin (what the matrix3d maps to)
        const relC = stagePx.map(c => [c[0] - bx, c[1] - by]);
        const H    = _computeHomography([[0, 0], [bw, 0], [bw, bh], [0, bh]], relC);
        const m3d  = _homographyToCSS(H);

        console.log(`[hc] zone=${zone} handle=${handle}`);
        console.log('Natural image size:', img?.naturalWidth, img?.naturalHeight);
        console.log('Displayed image size:', Math.round(rw), Math.round(rh));
        console.log('Image offset in stage:', Math.round(rx), Math.round(ry));
        console.log('Corner % → px:', relC.map(c => c.map(v => +v.toFixed(1))));
        console.log('Text element natural size (bw×bh):', +bw.toFixed(1), +bh.toFixed(1));
        console.log('Homography H:', H.map(r => r.map(v => +v.toPrecision(6))));
        console.log('H[2][0] (x-perspective):', +H[2][0].toPrecision(6), '  H[2][1] (y-perspective):', +H[2][1].toPrecision(6));
        console.log('matrix3d:', m3d);

        const applyEl = el => {
          if (!el) return;
          el.style.left            = (bx / sw * 100) + '%';
          el.style.top             = (by / sh * 100) + '%';
          el.style.width           = (bw / sw * 100) + '%';
          el.style.height          = (bh / sh * 100) + '%';
          el.style.transformOrigin = '0 0';
          el.style.transform       = m3d;
        };

        const canvas  = this.querySelector(`[data-stage-canvas="${zone}"]`);
        const overlay = this.querySelector(`[data-zone-overlay="${zone}"]`);
        if (canvas) { applyEl(canvas); canvas.removeAttribute('hidden'); }
        applyEl(overlay);
      });
    }

    _clearStageCanvas(zone) {
      const dst = this.querySelector(`[data-stage-canvas="${zone}"]`);
      if (!dst) return;
      dst.getContext('2d').clearRect(0, 0, dst.width, dst.height);
    }

    _mirrorToStage(zone, srcCanvas) {
      const dst = this.querySelector(`[data-stage-canvas="${zone}"]`);
      if (!dst) return;
      const dpr  = window.devicePixelRatio || 1;
      // Use offsetWidth/offsetHeight (layout dims) — getBoundingClientRect returns
      // the transformed visual box which is wrong after matrix3d is applied.
      const lw = dst.offsetWidth, lh = dst.offsetHeight;
      if (lw > 0) {
        const bmpW = Math.round(lw * dpr);
        const bmpH = Math.round(lh * dpr);
        if (dst.width !== bmpW || dst.height !== bmpH) {
          dst.width  = bmpW;
          dst.height = bmpH;
        }
      }
      const ctx = dst.getContext('2d');
      ctx.clearRect(0, 0, dst.width, dst.height);
      ctx.drawImage(srcCanvas, 0, 0, dst.width, dst.height);
    }

    // ── Shape drawing ─────────────────────────────────────────────────────────
    _shape(ctx, shape, cx, cy, r) {
      if (shape === 'circle') {
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.closePath();
      } else if (shape === 'octagon') {
        const rx = r * 1.45, ry = r * 1.45;
        ctx.beginPath();
        for (let i = 0; i < 8; i++) {
          const a = (i * Math.PI / 4) - Math.PI / 8;
          const x = cx + rx * Math.cos(a), y = cy + ry * Math.sin(a);
          i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        }
        ctx.closePath();
      } else if (shape === 'heart') {
        const hw = r * 1.45, hh = r * 1.45;
        ctx.beginPath();
        ctx.moveTo(cx, cy + hh);
        ctx.bezierCurveTo(cx,             cy + hh,          cx - hw,           cy + hh * 0.333, cx - hw,           cy - hh * 0.389);
        ctx.bezierCurveTo(cx - hw,        cy - hh * 0.722,  cx - hw * 0.737,   cy - hh,         cx - hw * 0.395,   cy - hh        );
        ctx.bezierCurveTo(cx - hw * 0.221,cy - hh,          cx - hw * 0.063,   cy - hh * 0.911, cx,                cy - hh * 0.778);
        ctx.bezierCurveTo(cx + hw * 0.063,cy - hh * 0.911,  cx + hw * 0.221,   cy - hh,         cx + hw * 0.395,   cy - hh        );
        ctx.bezierCurveTo(cx + hw * 0.737,cy - hh,          cx + hw,           cy - hh * 0.722, cx + hw,           cy - hh * 0.389);
        ctx.bezierCurveTo(cx + hw,        cy + hh * 0.333,  cx,                cy + hh,         cx,                cy + hh        );
        ctx.closePath();
      }
    }

    // ── Embroidered text rendering ────────────────────────────────────────────
    // ctx.font / textAlign / textBaseline must be set before calling.
    _drawEmbroidered(ctx, text, x, y, fill) {
      const r = parseInt(fill.slice(1, 3), 16);
      const g = parseInt(fill.slice(3, 5), 16);
      const b = parseInt(fill.slice(5, 7), 16);
      const clamp = v => Math.max(0, Math.min(255, v));
      // Perceived luminance — determines whether shadow goes dark or light
      const luma = 0.2126 * r / 255 + 0.7152 * g / 255 + 0.0722 * b / 255;
      const isDark = luma < 0.45;
      const shift = isDark ? +90 : -70;
      const contrast = `rgb(${clamp(r + shift)},${clamp(g + shift)},${clamp(b + shift)})`;

      // 1. Drop shadow — offset contrast copy drawn first, main fill covers the overlap
      ctx.save();
      ctx.globalAlpha = 0.48;
      ctx.fillStyle = contrast;
      ctx.fillText(text, x + 2, y + 2.5);
      ctx.restore();

      // 2. Main fill
      ctx.save();
      ctx.globalAlpha = 1;
      ctx.fillStyle = fill;
      ctx.fillText(text, x, y);
      ctx.restore();

      // 3. Inner edge glow — stroke clipped to text pixels via source-atop
      //    Only the inner half of the stroke (inside letter edges) is visible
      ctx.save();
      ctx.globalCompositeOperation = 'source-atop';
      ctx.globalAlpha = 0.42;
      ctx.strokeStyle = contrast;
      ctx.lineWidth = 4;
      ctx.lineJoin = 'round';
      ctx.strokeText(text, x, y);
      ctx.restore();

      // 4. Top-left specular highlight — simulates light catching the thread surface
      //    Gradient fades from bright top-left to transparent, clipped to letter pixels
      const dpr = window.devicePixelRatio || 1;
      const cW  = ctx.canvas.width  / dpr;
      const cH  = ctx.canvas.height / dpr;
      ctx.save();
      ctx.globalCompositeOperation = 'source-atop';
      const hlGrad = ctx.createLinearGradient(0, 0, cW * 0.55, cH * 0.55);
      hlGrad.addColorStop(0,   `rgba(${clamp(r+130)},${clamp(g+130)},${clamp(b+130)},0.52)`);
      hlGrad.addColorStop(0.4, `rgba(${clamp(r+80)}, ${clamp(g+80)}, ${clamp(b+80)}, 0.18)`);
      hlGrad.addColorStop(1,   `rgba(${clamp(r+60)}, ${clamp(g+60)}, ${clamp(b+60)}, 0)`);
      ctx.fillStyle = hlGrad;
      ctx.fillRect(0, 0, cW, cH);
      ctx.restore();

      ctx.fillStyle = fill;
    }

    // ── Image upload ──────────────────────────────────────────────────────────
    _processImage(file, zone) {
      if (file.size > 5 * 1024 * 1024) { alert('Image must be under 5 MB.'); return; }
      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.onload = () => {
          const MAX = 240, sc = Math.min(MAX / img.width, MAX / img.height, 1);
          const c = document.createElement('canvas');
          c.width  = Math.round(img.width  * sc);
          c.height = Math.round(img.height * sc);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          const dataUrl = c.toDataURL('image/png', 0.85);
          this._s.zones[zone].image = dataUrl;
          this._showImagePreview(zone, dataUrl);
          this._drawZone(zone);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    _showImagePreview(zone, dataUrl) {
      const area  = this.querySelector(`[data-upload-area="${zone}"]`);
      const img   = this.querySelector(`[data-upload-preview="${zone}"]`);
      const ph    = this.querySelector(`[data-upload-placeholder="${zone}"]`);
      const clear = this.querySelector(`[data-upload-clear="${zone}"]`);
      if (area)  area.classList.add('has-image');
      if (img)   { img.src = dataUrl; img.hidden = false; }
      if (ph)    ph.hidden = true;
      if (clear) clear.hidden = false;
    }

    _clearImage(zone) {
      this._s.zones[zone].image = null;
      const area  = this.querySelector(`[data-upload-area="${zone}"]`);
      const img   = this.querySelector(`[data-upload-preview="${zone}"]`);
      const ph    = this.querySelector(`[data-upload-placeholder="${zone}"]`);
      const clear = this.querySelector(`[data-upload-clear="${zone}"]`);
      const input = this.querySelector(`[data-zone-upload="${zone}"]`);
      if (area)  area.classList.remove('has-image');
      if (img)   { img.src = ''; img.hidden = true; }
      if (ph)    ph.hidden = false;
      if (clear) clear.hidden = true;
      if (input) input.value = '';
      this._drawZone(zone);
    }

    // ── Review ────────────────────────────────────────────────────────────────
    _buildReview() {
      const variants  = window.__hcVariants || [];
      const variant   = variants.find(v => v.id === this._s.variantId);
      const optionVals = Object.values(this._s.selectedOptions).join(' · ');

      const summary = this.querySelector('.hc-review-summary');
      if (summary) {
        summary.innerHTML = `
          <div class="hc-review-row">
            <span class="hc-review-label">Variant</span>
            <span class="hc-review-value">${variant?.title || optionVals || '—'}</span>
          </div>
          <div class="hc-review-row">
            <span class="hc-review-label">Front Logo</span>
            <span class="hc-review-value">${(() => {
              const { logo, oReplacement } = this._s.front;
              if (!logo) return '—';
              const labels = { logo1: 'IT JUST DOESN\'T STOP', logo2: 'IJDS', logo3: 'IJDS Wave Logo' };
              let label = labels[logo] || logo;
              if (logo === 'logo1' && oReplacement) label += ` · ${oReplacement} O`;
              return label;
            })()}</span>
          </div>
          <div class="hc-review-row">
            <span class="hc-review-label">Panels customized</span>
            <span class="hc-review-value">${Object.values(this._s.zones).filter(z => z.type !== 'none').length} of 3</span>
          </div>
        `;
      }

      const grid = this.querySelector('.hc-review-grid');
      if (grid) {
        grid.innerHTML = '';
        const hatBg = '#1c1c1c';
        [['left', 'Left Side'], ['right', 'Right Side'], ['back', 'Back']].forEach(([key, label]) => {
          const z    = this._s.zones[key];
          const item = document.createElement('div');
          item.className = 'hc-review-item';
          let content;
          if (z.type === 'none') {
            content = `<span class="hc-review-empty">Blank</span>`;
          } else if (z.type === 'text') {
            content = `<p style="font-family:${FONT_MAP[z.font] || FONT_MAP.full_block};color:${z.color};font-size:1rem;font-weight:bold;padding:6px;text-align:center;word-break:break-all">${z.text || '(empty)'}</p>`;
          } else if (z.type === 'image' && z.image) {
            content = `<img src="${z.image}" alt="" style="max-width:100%;max-height:80px;object-fit:contain;border-radius:4px">`;
          } else {
            content = `<span class="hc-review-empty">No image</span>`;
          }
          item.innerHTML = `<h3>${label}</h3><div class="hc-review-card" style="background:${hatBg}">${content}</div>`;
          grid.appendChild(item);
        });
      }
    }

    // ── Cart submit ───────────────────────────────────────────────────────────
    _addToCart() {
      const variantId = this._s.variantId;
      if (!variantId) { alert('Please select a variant before adding to cart.'); return; }

      const { zones, front } = this._s;

      // ── Human-readable properties (no _ prefix → shown in cart/orders) ───────
      const LOGO_LABEL = { logo1: "IT JUST DOESN'T STOP", logo2: 'IJDS', logo3: 'IJDS Wave Logo' };
      const ZONE_LABEL = { left: 'Left Side', right: 'Right Side', back: 'Back' };
      const colorName  = hex => THREAD_COLORS.find(t => t.hex === hex)?.name || hex;

      const visibleProps = {};
      if (front.logo) {
        visibleProps['Front Logo'] = LOGO_LABEL[front.logo] || front.logo;
        if (front.logo === 'logo1' && front.oReplacement) {
          visibleProps["O Replacement"] = front.oReplacement.charAt(0).toUpperCase() + front.oReplacement.slice(1);
        }
        if (front.color && front.logo !== 'logo3') {
          visibleProps['Front Thread Color'] = colorName(front.color);
        }
      }
      ['left', 'right', 'back'].forEach(zone => {
        const z = zones[zone];
        if (z.type === 'none') return;
        if (z.type === 'text') {
          visibleProps[ZONE_LABEL[zone]] = z.text ? `Text — "${z.text}"` : 'Text (blank)';
        } else if (z.type === 'image') {
          visibleProps[ZONE_LABEL[zone]] = 'Logo upload (image on file)';
        } else if (z.type === 'headphone') {
          visibleProps[ZONE_LABEL[zone]] = 'Headphone Logo';
        }
      });

      // ── Internal properties (_ prefix → hidden from cart display) ────────────
      const internalProps = {
        _front_logo:      front.logo || '',
        _front_o_replace: front.oReplacement || '',
        _front_color:     front.color || '',
      };
      ['left', 'right', 'back'].forEach(zone => {
        const z = zones[zone];
        internalProps[`_${zone}_type`]  = z.type;
        internalProps[`_${zone}_text`]  = z.type === 'text'  ? z.text  : '';
        // Image data is intentionally omitted — too large for cart properties.
        // If the zone had an upload, the visible prop above notes it.
        internalProps[`_${zone}_image`] = z.type === 'image' ? 'uploaded' : '';
      });

      // Unique pairing ID — links the hat to its add-on line items in the cart
      const _cid = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2) + Date.now().toString(36);

      // Count how many add-on line items will be created
      let _addonCount = 0;
      ['left', 'right', 'back'].forEach(zone => {
        if (zones[zone].type !== 'none' && ADD_ON_VARIANTS[zones[zone].type === 'image' ? 'upload' : 'text']) _addonCount++;
      });

      internalProps._cid = _cid;
      if (_addonCount > 0) internalProps._addon_count = String(_addonCount);

      const hatProps = { ...visibleProps, ...internalProps };

      // Mirror to hidden inputs (internal props only)
      Object.entries(internalProps).forEach(([key, val]) => {
        const el = this.querySelector(`[data-hc-prop="${key.replace(/^_/, '')}"]`);
        if (el) el.value = val;
      });

      // Build items array — hat first, then add-ons
      const qtyInput = this.querySelector('.hc-qty-input');
      const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      const items = [{ id: variantId, quantity, properties: hatProps }];

      ['left', 'right', 'back'].forEach(zone => {
        const z = zones[zone];
        if (z.type === 'none') return;
        const addonId = z.type === 'image' ? ADD_ON_VARIANTS.upload : ADD_ON_VARIANTS.text;
        if (!addonId) return;
        const addonProps = { _zone: zone, _type: z.type, _cid };
        if (z.type === 'text') addonProps._text = z.text;
        items.push({ id: addonId, quantity: 1, properties: addonProps });
      });

      const btn = this.querySelector('#hc-add-to-cart');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(() => {
          this._refreshCartCount();
          this._showCartAdded();
        })
        .catch(() => {
          if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
          alert('Could not add to cart. Please try again.');
        });
    }

    // ── Refresh the header cart bubble count ──────────────────────────────────
    _refreshCartCount() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(({ item_count }) => {
          // Horizon theme cart bubble
          const bubble = document.querySelector('.cart-bubble');
          const countEl = document.querySelector('.cart-bubble__text-count');
          if (countEl) countEl.textContent = item_count;
          if (bubble) bubble.classList.toggle('visually-hidden', item_count === 0);
          // Also dispatch events the theme may listen for
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('hat-customizer:added', { bubbles: true, detail: { item_count } }));
        })
        .catch(() => {});
    }

    // ── Post-add confirmation overlay (shown inside the still-open customizer) ─
    _showCartAdded() {
      // Remove any stale overlay
      this.querySelector('.hc-cart-added')?.remove();

      const overlay = document.createElement('div');
      overlay.className = 'hc-cart-added';
      overlay.innerHTML = `
        <div class="hc-cart-added-card">
          <div class="hc-cart-added-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <h2 class="hc-cart-added-title">Added to your cart!</h2>
          <p class="hc-cart-added-sub">Your custom hat has been saved to your cart.</p>
          <div class="hc-cart-added-actions">
            <button type="button" class="hc-cart-added-btn hc-cart-added-continue">Continue Shopping</button>
            <a href="/cart" class="hc-cart-added-btn hc-cart-added-checkout">View Cart →</a>
          </div>
        </div>`;

      this.appendChild(overlay);

      overlay.querySelector('.hc-cart-added-continue')?.addEventListener('click', () => {
        overlay.remove();
        this._close();
      });
    }
  }

  if (!customElements.get('hat-customizer')) {
    customElements.define('hat-customizer', HatCustomizer);
  }
})();
